export const keyList = Object.keys;

export const noop = () => { };


// WEBPACK FOOTER //
// ./src/components/bewise/Tabs/easyConst.js